import {
  createFileRoute,
  redirect,
  retainSearchParams,
} from "@tanstack/react-router";
import { z } from "zod";
import { LandingPage } from "@/features/landing";

export const Route = createFileRoute("/_landing/")({
  component: Index,
  loader: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: "/avtaler",
        throw: true,
      });
    }
  },
  validateSearch: z.object({
    errorCode: z.string().optional(),
  }).parse,
  search: {
    // Get error status from search params and retain it for the landing page
    middlewares: [retainSearchParams(["errorCode"])],
  },
});

function Index() {
  const { errorCode } = Route.useSearch?.() ?? { errorCode: undefined };
  if (errorCode) {
    console.log("Error message from search params:", errorCode);
  }
  return <LandingPage errorCode={errorCode} />;
}
